import React from 'react';
import { Button, Tabs } from 'antd';
import { useHistory } from 'react-router-dom';
import { SlidersOutlined } from '@ant-design/icons';

import styled from 'styled-components';
import SimuladorRe from './organisms/SimuladorRe';

const TabsWrapper = styled(Tabs)`
  width: 100%;
`;

function Simulador() {
  const history = useHistory();

  const SettingsLink = (
    <Button
      type="link"
      onClick={() => {
        history.push('/settings');
      }}
      icon={
        <span className="anticon">
          <SlidersOutlined size="lg" />
        </span>
      }
    >
      Parametrização
    </Button>
  );

  return (
    <TabsWrapper
      defaultActiveKey="1"
      tabBarExtraContent={{ right: SettingsLink }}
    >
      <Tabs.TabPane tab="Remuneração Estratégica (RE)" key="1">
        <SimuladorRe />
      </Tabs.TabPane>
    </TabsWrapper>
  );
}

export default Simulador;
